import { useState, SyntheticEvent } from "react";
import { Link, Outlet } from "react-router-dom";

// material-ui
import { Box, Tab, Tabs } from "@mui/material";

// project-imports
import MainCard from "components/MainCard";

// assets
import { TableDocument } from "iconsax-react";

// ==============================|| PROFILE - ACCOUNT ||============================== //

const AccountProfile = () => {
  //   const { pathname } = useLocation();

  let selectedTab = 0;
  //   switch (pathname) {
  //     case "/apps/profiles/account/personal":
  //       selectedTab = 1;
  //       break;
  //     case "/apps/profiles/account/my-account":
  //       selectedTab = 2;
  //       break;
  //     case "/apps/profiles/account/password":
  //       selectedTab = 3;
  //       break;
  //     case "/apps/profiles/account/role":
  //       selectedTab = 4;
  //       break;
  //     case "/apps/profiles/account/settings":
  //       selectedTab = 5;
  //       break;
  //     case "/apps/profiles/account/basic":
  //     default:
  //       selectedTab = 0;
  //   }

  const [value, setValue] = useState(selectedTab);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <MainCard border={false}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="account profile tab"
        >
          <Tab
            label="Settings"
            component={Link}
            to="/account/setting"
            icon={<TableDocument />}
            iconPosition="start"
          />
        </Tabs>
      </Box>
      <Box sx={{ mt: 2.5 }}>
        <Outlet />
      </Box>
    </MainCard>
  );
};

export default AccountProfile;
